import {
  copyFileById,
  destroyFile,
  forceFileDownload,
  getMongoFileId,
  getPrincipalName,
  getTokenHeader,
  getThumbnailUrl,
  getPictureUrlDatePath
} from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment";
import "./POI.scss";
import _ from "lodash";
import { v4 as uuid } from "uuid";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import POIFilter from "@/components/POI/POIFilter/POIFilter.vue";
import POIEditDialog from "@/components/POI/POIEditDialog/POIEditDialog.vue";
import ExportXslxDialog from "@/components/POI/ExportXslxDialog/ExportXslxDialog.vue";
import ExportCsvDialog from "@/components/POI/ExportCsvDialog/ExportCsvDialog.vue";
import { buildQuery, defaultPoi, getPois } from "@/helpers/poiHelper";
import { uploadFile } from "@/helpers/fileHelper";
import XLSX from "xlsx";
import { imports } from "@/helpers/poiHelper";
import { updateOpLoc } from "@/helpers/opLocHelper";
import ImagePreviewButton from "../../components/Common/ImagePreviewButton/ImagePreviewButton.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultFilter = {
  itemsPerPage: 10
};

let initialOptions = {
  itemsPerPage: 10
};

export default {
  name: "POI",
  props: ["editId"],
  data: () => ({
    loading: true,
    isValid: false,
    dialog: false,
    typeDialog: false,
    dialogDelete: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    search: "",
    defaultFilter: {
      itemsPerPage: 10,
      categoryGroup: "",
      category: "",
      city: "",
      features: [],
      active: false,
      highlight: false
    },
    headers: [
      {
        text: "Vorschaubild",
        align: "start",
        value: "image",
        sortable: false
      },
      {
        text: "",
        align: "start",
        value: "import",
        sortable: false
      },
      {
        text: "Ortsname",
        align: "start",
        value: "title"
      },
      { text: "Typ", value: "categoryType" },
      { text: "Kategorie", value: "categoryTitle" },
      { text: "Ort", value: "address.city" },
      { text: "Zuletzt geändert", value: "updatedAt" },
      { text: "Aktiv (Veröffentlicht)", value: "active" },
      { text: "Top-POI", value: "highlight" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "10%"
      }
    ],
    showPreviewImage: false,
    editedIndex: -1,
    editedItem: {
      title: "",
      subTitle: "",
      shortTitle: "",
      sortTitle: "",
      category: "",
      additionalCategories: [],
      slug: "",
      manualSlug: false,
      highlight: false,
      active: true,
      name: "",
      area: "",
      nation: "",
      address: { country: "Deutschland" },
      online: {},
      webcamLinks: [{}],
      showWebcamsFirst: false,
      mainFiles: [],
      fileFiles: [],
      pictures: [],
      files: [],
      openingHours: {
        freeAccess: true,
        closedDays: [{}],
        seasonalOpeningHours: [],
        specialDays: [{}],
        description: {
          description: "",
          seasonalDescription: "",
          arrivalInformation: "",
          hygieneNoticeText: "",
          hygieneNoticeIUrl: ""
        }
      },
      state: {
        lastAscent: "", // Zeit
        lastDescent: "", // Zeit
        firstAscent: "", // Zeit
        ascent: undefined,
        descent: undefined,
        seasonStart: "",
        seasonEnd: "",
        prognosisCountLift: undefined,
        prognosisCountTrailClassic: undefined,
        prognosisCountTrailSkating: undefined,
        prognosisCountTrail: undefined,
        prognosisLengthLift: undefined,
        prognosisLengthTrail: undefined,
        prognosisLengthTrailClassic: undefined,
        prognosisLengthTrailSkating: undefined,
        state: "openingHours",
        stateInfo: "",
        valleySnowDepth: undefined,
        mountainSnowDepth: undefined,
        avalancheLevel: "",
        lastSnowFall: "",
        freshSnow: undefined,
        capacityPerUnit: undefined,
        carriage: undefined,
        drivingTime: "",
        valleySeaLevel: undefined,
        mountainSeaLevel: undefined,
        height: undefined,
        valleyLength: undefined,
        heightDifference: undefined,
        hasSnowMaking: false,
        hasValleyRun: false,
        lakeTemperature: "",
        waterQuality: "",
        temperature: undefined,
        difficulty: "",
        trackType: "",
        walkingTime: "", // Zeit
        floodlightAt: [],
        floodlightFrom: "", // Zeit
        floodlightUntil: "", // Zeit
        lastTimeGroomed: "", // Zeit
        lastDateGroomed: "",
        length: undefined,
        lowestHeight: undefined,
        highestHeight: undefined,
        snowTexture: "",
        pathCondition: [],
        bestSeason: [],
        location: "",
        condition: undefined,
        slopeCondition: "",
        experienceFactor: undefined,
        landscapeFactor: undefined,
        weatherCondition: "",
        sight: "",
        withWithoutParkingFee: "",
        parkingPayment: [],
        maxParkingTime: null,
        parkingTime: null,
        parkingFee: null
      },
      pricePackages: [
        {
          id: 1,
          services: [],
          tableTitle: "Preise"
        }
      ],
      route: {
        gpx: { title: "", url: "", id: "" },
        image: { title: "", url: "", id: "" },
        description: {
          publicTransit: "",
          startingPointDescr: "",
          parking: "",
          equipment: "",
          tip: "",
          additionalInformation: "",
          destination: "",
          directions: "",
          safetyGuidelines: "",
          trackSignage: ""
        }
      },
      currentMessage: {},
      features: [],
      seasonWeeks: [{ id: uuid() }],
      contact: {
        showContact: "address"
      },
      additionalData: [{}],
      license: {},
      geo: {},
      searchTerms: [],
      relatedPois: [],
      description: { description: "", seasonalDescription: "" },
      shortDescription: { description: "", seasonalDescription: "" },
      principal: "",
      regions: [],
      excursionTickers: [],
      exhibitions: [],
      contactPerson: {
        name: "",
        gender: "",
        title: "",
        phoneNumber: "",
        eMail: "",
        picture: {}
      },
      conferenceInfos: {
        rooms: []
      }
    },
    changed: false,

    pois: [],
    allPois: [],
    overlay: false,
    exportData: [],
    poiCount: 0,
    options: {
      ...initialOptions
    },
    step: 1,
    filter: { ..._.cloneDeep(defaultFilter) },
    MAIN_GREEN: "#00636C",
    MAIN_GREY: "#7a7a7a",
    exportingImages: false,
    destroyList: [],
    currentSearchRequest: null,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0
  }),
  components: {
    ImagePreviewButton,
    POIFilter,
    POIEditDialog,
    ExportXslxDialog,
    ExportCsvDialog
  },
  async mounted() {
    const itemsPerPage = defaultFilter.itemsPerPage;
    this.showPreviewImage = JSON.parse(
      localStorage.getItem("showPreviewImage")
    );
    this.filter.itemsPerPage = this.filter.limit = itemsPerPage;
    await this.refreshPois(this.options);
    if (this.principal) {
      try {
        await this.$store.dispatch("getCategoryGroups", false);
        await this.$store.dispatch("getAllUsers");
        await this.$store.dispatch("getCategoryTypes");
        await this.$store.dispatch("getCities");
        await this.$store.dispatch("getRegions", { listSearch: true });
        await this.$store.dispatch("getFeatureGroupsForPois", this.isRegion);
        await this.$store.dispatch("getThirdPartySystems", { module: "POIs" });
        if (this.editId) {
          const headers = getTokenHeader();
          const { data: poiToEdit } = await axios.get(
            `${env.poi_api_client_url}poi/${this.editId}`,
            {
              headers
            }
          );
          await this.editItem(poiToEdit);
        }
        this.loading = false;
      } catch (ex) {
        this.createError(ex);
      }
    } else alert("Bitte wählen sie einen Mandanten aus");
  },

  computed: {
    currentHeaders() {
      if (!this.showPreviewImage)
        return this.headers.filter(i => i.value !== "image");
      return this.headers;
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal._id;
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    categoryTypesById() {
      return this.$store.state.categoryTypesById;
    },
    categoryGroupsForPoi() {
      return this.categoryGroups?.filter(cg => {
        if (cg.categoryType !== this.editedItem.categoryType) {
          return false;
        }

        if (Array.isArray(cg.services)) {
          return !cg.services?.length;
        }
        return true;
      });
    },
    categories() {
      return _.flatten(
        this.$store.state.categoryGroups?.map(ct => ct.categories)
      );
    },
    categoriesByGroup() {
      return this.$store.state.categories;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    categoriesById() {
      const categoriesById = {};

      this.categories?.forEach(cat => {
        categoriesById[cat._id] = cat.title;
      });
      return categoriesById;
    },
    categoryGroups() {
      return this.$store.state.categoryGroups;
    },
    categoryGroupById() {
      return this.$store.state.categoryGroupsById;
    },
    users() {
      return this.$store.state.users;
    },
    cities() {
      return this.$store.state.cities;
    },
    principals() {
      return this.$store.state.principals;
    },

    isRegion() {
      return (
        this.$store.state.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    },
    featureGroups() {
      return this.$store.state.featureGroups;
    },
    regions() {
      return _.sortBy(this.$store.state.regions, "title");
    },
    customPoiImageTypes() {
      return this.principal?.poiImageTypes || [];
    },
    activeImports() {
      return imports.filter(_ => _.isActive(this.principal)).map(_ => _.typeId);
    }
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    async principal() {
      try {
        await this.refreshPois(this.options);
        await this.$store.dispatch("getCategoryGroups");
        await this.$store.dispatch("getCategoryTypes");
      } catch (ex) {
        this.createError(ex);
      }
    },
    async options(value) {
      // Check if the options have really changed
      initialOptions.itemsPerPage = 10;
      const isEqual = Object.keys(value).every(
        key => initialOptions[key] === value[key]
      );
      if (isEqual) {
        console.info("options are equal. no need to refresh pois");
        initialOptions.firstLoad = true;
        return;
      }

      this.debouncedRefreshPois();
    },
    search(value) {
      if (value?.length >= 3 || !value?.length) {
        this.debouncedRefreshPois();
      }
    },
    editedItem() {
      this.changed = true;
    },
    dialog(value) {
      if (value) {
        // Wait for Stepper to load
        setTimeout(() => {
          // Get stepper-numbering
          const steps = document.getElementsByClassName(
            "v-stepper__step__step"
          );

          // Overwrite numbering with index
          steps.forEach((step, index) => {
            step.innerHTML = index + 1;
          });
        }, 500);
      }
    },
    // Watchers needed to prevent the v-slider component forcing the values to be 0.
    "editedItem.state.experienceFactor"(newValue, oldValue) {
      this.forceUndefinedInsteadOfZeroStateValue(
        newValue,
        oldValue,
        "experienceFactor"
      );
    },
    "editedItem.state.landscapeFactor"(newValue, oldValue) {
      this.forceUndefinedInsteadOfZeroStateValue(
        newValue,
        oldValue,
        "landscapeFactor"
      );
    },
    "editedItem.state.condition"(newValue, oldValue) {
      this.forceUndefinedInsteadOfZeroStateValue(
        newValue,
        oldValue,
        "condition"
      );
    }
  },
  created() {
    this.debouncedRefreshPois = _.debounce(() => {
      this.refreshPois(this.options)
        .then(() => {
          console.info("poisearch refreshed/cancelled");
        })
        .catch(err => {
          console.error("Error in search watcher: ", err);
          this.createError(err);
        });
    }, 200);
  },
  methods: {
    updateOpLoc,
    getPrincipalName,
    getThumbnailUrl,
    nextPage() {
      const total = this.poiCount;
      const perPage = this.itemsPerPage;
      const totalPages = Math.ceil(total / perPage);

      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    setShowPreviewImage() {
      this.showPreviewImage = !this.showPreviewImage;
      localStorage.setItem("showPreviewImage", this.showPreviewImage);
    },
    getCategoryType(categoryType) {
      const foundCatType = this.categoryTypes.find(
        ct => ct._id === categoryType
      );
      if (foundCatType?.title) return foundCatType.title;
      else return "---";
    },
    morePictures(item) {
      return item.allPictures > 1;
    },
    previewImage(item) {
      const url = item?.picture?.url;
      return this.getThumbnailUrl(url, "pois", 70, "-");
    },
    setToLocalStorage(value) {
      localStorage.setItem("itemsPerPage", value);
    },
    async getPoi(item) {
      const headers = getTokenHeader();
      try {
        const { data } = await axios.get(
          `${env.poi_api_client_url}poi/${item._id}`,
          {
            headers
          }
        );
        return data;
      } catch (error) {
        this.createError(error);
      }
    },
    async editItem(item) {
      this.editedIndex = this.pois.indexOf(item);
      const data = await this.getPoi(item);

      /***************************************************************
       * Lodash merge, damit Subobjekte übernommen werden
       *
       * Das leere Objekt am Anfang ist dafür, dass das defaultItem
       * nicht überschrieben wird
       ***************************************************************/
      this.editedItem = _.merge({}, defaultPoi, data);
      await this.$store.dispatch(
        "getCategoriesByGroup",
        this.editedItem.categoryGroup
      );
      this.changed = false;
      this.dialog = true;
    },
    async deletePoi(poi) {
      const id = poi._id;
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie dieses Element löschen wollen?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        const data = await this.getPoi(poi);
        data.pictures.forEach(pic => {
          destroyFile("pois", pic.id);
        });
        if (data.logo) {
          destroyFile("pois", getMongoFileId({ url: data.logo }));
        }
        if (data.route?.gpx?.url) {
          destroyFile("pois", getMongoFileId(data.route.gpx));
        }
        if (data.route?.image?.id) {
          destroyFile("pois", data.route.image.id);
        }
        try {
          const headers = getTokenHeader();
          const res = await axios.delete(`${env.poi_api_client_url}poi/${id}`, {
            headers
          });
          if (res.status === 200) {
            await this.refreshPois(this.options);
            this.createSuccess("Erfolgreich gelöscht!");
          }
        } catch (error) {
          this.createError(error);
        }
      }
    },
    async close() {
      if (this.changed) {
        const isConfirmed = await this.$confirm(
          "Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!",
          confirmWarningConfig
        );
        if (isConfirmed) {
          this.editedItem = Object.assign({}, this.editedItem); // reactivity
          this.closeAction();
        }
      } else this.closeAction();
    },
    closeAction() {
      this.dialog = false;
      this.isValid = true;
      this.$nextTick(() => {
        this.$refs.editDialog?.$refs?.stepWrapper?.$refs?.media?.clear();
        this.$refs.editDialog?.$refs?.stepWrapper?.$refs?.processingStatus?.$refs?.logOverview?.resetLogs();
        this.$refs.form?.reset();

        this.step = 1;
        this.editedItem = Object.assign({}, { ...defaultPoi });
        this.editedIndex = -1;
        if (this.editId) this.$router.replace("/poi");
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, { ...defaultPoi });
        this.editedIndex = -1;
      });
    },
    async save(close) {
      let response = false;
      if (!this.editedItem.principal)
        this.editedItem.principal = this.principal.id;

      try {
        if (this.editedItem.logo && typeof this.editedItem.logo !== "string") {
          const res = await uploadFile(
            this.editedItem.logo,
            this.editedItem.id || this.editedItem._id,
            "pois",
            this.editedItem.principal
          );
          this.editedItem.logo = res.url;
        }

        if (this.editedItem.features?.some(f => typeof f === "object"))
          this.editedItem.features = this.editedItem.features.filter(
            feature => !!feature
          );

        response = this.editedItem._id
          ? await this.updatePoi()
          : await this.createPoi();
      } catch (ex) {
        this.createError(ex);
      }

      this.destroyList.forEach(id => {
        destroyFile("pois", id);
      });
      this.destroyList = [];

      if (response?.status === 200 || response?.status === 201) {
        try {
          await this.refreshPois(this.options);
        } catch (ex) {
          this.createError(ex);
          return;
        }
        // update calculatedOpeningHours in gui
        // f.e. used for closedWeekDays
        if (response?.data?.calculatedOpeningHours) {
          this.editedItem.calculatedOpeningHours =
            response.data.calculatedOpeningHours;
          // reactivity
          this.editedItem = Object.assign({}, this.editedItem);
        }
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
        if (response?.status === 201 && response?.data?._id) {
          const createdPoi = await axios.get(
            `${env.poi_api_client_url}poi/${response.data._id}`,
            {
              headers: getTokenHeader()
            }
          );

          this.editedItem = createdPoi.data;
          this.editedItem = Object.assign(
            {
              ...defaultPoi
            },
            this.editedItem
          );
        }

        const logOverviewRef = this.$refs.editDialog.$refs.stepWrapper.$refs
          .processingStatus.$refs.logOverview;
        const logsFetched = logOverviewRef?.logsFetched;
        logOverviewRef?.resetLogs();

        if (close) {
          this.closeAction();
        } else if (logsFetched) {
          logOverviewRef?.getLogs().then(null);
        }
      }
    },
    async createPoi(poi) {
      if (!poi) poi = this.editedItem;
      const headers = getTokenHeader(),
        res = await axios.post(`${env.poi_api_client_url}poi`, poi, {
          headers
        });
      return res.status >= 200 && res.status < 300 ? res : false;
    },
    async updateOplocHelper(poi) {
      if (!poi?.events_module?.oploc_id?.length) return;
      const types = [];

      if (poi?.events_module?.isOperator) types.push("operator");
      if (poi?.events_module?.isLocation) types.push("location");

      if (!types?.length) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens einen Typ auswählen!"
        });
        return;
      }

      const oplocToUpdate = {
        _id: poi.events_module?.oploc_id,
        title: poi.title,
        principal_id: poi.principal,
        poi_id: poi._id,
        type: types,
        address: {
          ...poi.address,
          additional_address: poi?.address?.additionalAddress || "",
          phone: poi?.address?.phoneNumber || "",
          mobile: poi?.address?.mobileNumber || "",
          email: poi?.address?.eMail || ""
        }
      };
      if (poi.geo.lng && poi.geo.lat) {
        oplocToUpdate.geo = {
          type: "Point",
          coordinates: [poi.geo.lng, poi.geo.lat]
        };
      } else {
        oplocToUpdate.geo = {
          type: "Point",
          coordinates: []
        };
      }

      await this.updateOpLoc(oplocToUpdate);
    },
    async updatePoi(poi) {
      if (!poi) poi = this.editedItem;
      if (poi?.events_module?.oploc_id?.length) {
        try {
          await this.updateOplocHelper(poi);
        } catch (e) {
          console.error(e);
          await this.$store.dispatch("createError", {
            text: "Fehler beim Aktualisieren des Veranstalters/Standorts"
          });
        }
      }
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.poi_api_client_url}poi/${poi.id || poi._id}`,
          poi,
          { headers }
        );
      return res.status >= 200 && res.status < 300 ? res : false;
    },
    createError(error) {
      this.$store.dispatch("createError", error);
    },
    createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    // Baut den updatedAt string für die Tabelle zusammen,
    // da moment im Template nicht verfügbar ist
    buildUpdatedAt: at => `${moment(at).format("DD.MM.YYYY HH:mm")}`,

    async changeCheckboxState(item, property) {
      if (!item.deleted) {
        const res = await this.$confirm(
          "Wollen Sie diese Änderung wirklich vornehmen?",
          confirmWarningConfig
        );
        if (res) item[property] = !item[property];
        const updatePoiData = { _id: item._id, slug: item.slug };
        updatePoiData[property] = item[property];
        await this.updatePoi(updatePoiData);
      }
    },
    changeStep(value) {
      this.step = value;
    },
    async resetFilter() {
      this.filter = { ..._.cloneDeep(defaultFilter) };
      await this.applyFilter(this.filter);
    },
    async applyFilter() {
      this.loading = true;
      await this.refreshPois(this.options);
      this.loading = false;
    },
    exportCsv(imageType) {
      this.downloadList("csv", imageType);
    },
    exportXlsx(imageType) {
      this.downloadList("xlsx", imageType);
    },
    async exportJson() {
      const data = await this.getExportPois();
      forceFileDownload(JSON.stringify(data), "pois.json");
    },
    async exportImages() {
      try {
        this.overlay = true;
        this.exportingImages = true;
        const exportPois = await this.getExportPois({ forImageExport: true });
        let _ids = [];
        exportPois.forEach(poiArray => {
          poiArray.forEach(poi => {
            _ids.push(poi._id);
          });
        });
        _ids = _.uniq(_ids);
        if (!_ids.length) return;

        const idBatches = _.chunk(_ids, 100);
        const headers = getTokenHeader();
        for (let i = 0; i < idBatches.length; i++) {
          const { data } = await axios.post(
            `${env.poi_api_client_url}poi/exportImages`,
            {
              _ids: idBatches[i]
            },
            {
              headers,
              responseType: "arraybuffer"
            }
          );
          const fileName =
            idBatches.length === 1 ? "poiBilder.zip" : `poiBilder_${i + 1}.zip`;
          forceFileDownload(data, fileName);
        }
      } catch (error) {
        this.createError(error);
      } finally {
        this.exportingImages = false;
        this.overlay = false;
      }
    },
    async getExportPois(options = {}) {
      let data = [];
      let queryIds = [[]];
      let index = 0;

      if (options.forImageExport && this.poiCount > 200) {
        const confirm = await this.$confirm(
          "Es werden die Bilder von mehr als 200 POIs exportiert. Dies kann einige Zeit in Anspruch nehmen. Wollen Sie fortfahren?",
          confirmWarningConfig
        );
        if (!confirm) {
          return [];
        }
      }

      await this.refreshPois({ ...this.options, getAllIds: true });

      this.allPois.forEach(id => {
        if (queryIds[index].length < 200) queryIds[index].push(id);
        else {
          queryIds.push([]);
          index++;
          queryIds[index].push(id);
        }
      });
      try {
        const headers = getTokenHeader();
        await queryIds.asyncForEach(async reqPackage => {
          const result = await axios.post(
            `${env.poi_api_client_url}poi/exportPois`,
            reqPackage,
            {
              headers
            }
          );
          if (result?.status === 200) {
            result?.data?.forEach(poi => {
              data.push(poi);
            });
          } else {
            this.createError("Etwas ist schiefgelaufen");
          }
        });
      } catch (error) {
        this.createError(error);
      }
      return data;
    },
    async refreshPois(options) {
      this.loading = true;
      // Cancel any in-progress requests
      if (this.currentSearchRequest) {
        this.currentSearchRequest.cancel(
          "Operation canceled due to new request"
        );
      }

      // Create a new cancellation token
      this.currentSearchRequest = axios.CancelToken.source();

      try {
        const query = buildQuery(
          options,
          this.search,
          this.filter,
          this.$store.state.selectedPrincipal
        );

        const result = await getPois(
          query,
          this.principal._id,
          this.currentSearchRequest.token
        );
        this.loading = false;

        this.allPois = result?.allIds[0];
        this.pois = result?.pois;
        if (!this.isAdmin) this.pois = this.pois.filter(poi => !poi.deleted);
        this.poiCount = result?.total;
      } catch (error) {
        if (axios.isCancel(error)) {
          console.info("Request cancelled successfully.");
          return;
        }
        this.loading = false;
        throw error;
      }
    },
    async downloadList(type, imageType) {
      const TABLE_TITLE_LINE = [
        "ID",
        "Titel",
        "Typ",
        "Kategorie",
        "Ort",
        "geändert",
        "durch",
        "aktiv (veröffentlicht)",
        "Top-POI",
        "Straße",
        "Adresse 2. Zeile",
        "PLZ",
        "Ort",
        "Land",
        "Telefon",
        "Mobil",
        "E-Mail",
        "Website",
        "Kontakt-Mail",
        "Bilder",
        "Mapping Felder",
        "Regionsberechtigung"
      ];
      const table = [TABLE_TITLE_LINE];
      this.overlay = true;
      const data = await this.getExportPois();
      data.forEach(nestedData => {
        nestedData.forEach(poi => {
          const address = poi[poi?.contact?.showContact];
          let poiImage = "";
          poi.pictures?.forEach(pic => {
            if (pic?.customTypes[0] === imageType) {
              poiImage = pic.url;
            }
            if (!poiImage && imageType === "1. Bild") {
              poiImage = pic.url;
            }
          });

          table.push([
            poi._id,
            poi.title,
            this.categoryTypesById[poi.categoryType] ?? "",
            this.categoriesById[poi.category] ?? "---",
            poi.address?.city,
            this.buildUpdatedAt(poi.updatedAt),
            this.getUpdatedByStringForExport(poi),
            poi.active ? 1 : 0,
            poi.highlight ? 1 : 0,
            address?.address ?? "",
            address?.additionalAddress ?? "",
            address?.zip ?? "",
            address?.city ?? "",
            address?.country ?? "",
            address?.phoneNumber ?? "",
            address?.mobileNumber ?? "",
            address?.eMail ?? "",
            address?.website ?? "",
            address?.contactEMail ?? "",
            poiImage,
            poi.additionalData
              ? poi.additionalData
                  .map(data => `${data.typeId}: ${data.value}`)
                  ?.join("; ")
              : "",
            this.getPermissionsForRegionsByPoi(poi)
          ]);
        });
      });
      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(table);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "POIs");
      XLSX.writeFile(workbook, `pois.${type}`);
      this.overlay = false;
    },
    getUpdatedByStringForExport(poi) {
      const updatedBy = this.getUsersNameById(poi.updatedBy);
      if (updatedBy?.trim()?.length) {
        return updatedBy;
      }
      if (poi.updatedByImport || poi.lastChangedImportDataSource) {
        return "Import";
      }
      return "----";
    },
    getUsersNameById(id) {
      const user = this.users.find(u => u.id === id);
      return `${user?.first_name ?? ""} ${user?.last_name ?? ""}`;
    },
    async cloneFiles(clone) {
      await clone.pictures.asyncForEach(async pic => {
        await this.copyPicture(pic);
      });
      if (clone.logo) {
        const newLogo = await copyFileById(
          getMongoFileId({ url: clone.logo }),
          getPictureUrlDatePath(clone.logo)
        );
        clone.logo = newLogo.url;
      }
      if (clone.route?.gpx?.url) {
        const newGpx = await copyFileById(
          getMongoFileId(clone.route.gpx),
          getPictureUrlDatePath(clone.route.gpx)
        );
        if (newGpx) {
          clone.route.gpx.id = newGpx.id;
          clone.route.gpx.url = newGpx.url;
        }
      }
      if (clone.route?.image?.url) {
        const newGpxImage = await copyFileById(
          clone.route.image.id,
          getPictureUrlDatePath(clone.route.image.url)
        );
        if (newGpxImage) {
          clone.route.image.id = newGpxImage.id;
          clone.route.image.url = newGpxImage.url;
        }
      }
    },
    async copyPoi(item) {
      const isConfirmed = await this.$confirm(
        "Möchten Sie dieses Element wirklich kopieren?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        const data = await this.getPoi(item);
        const clone = { ...data, active: false };
        delete clone.slug;
        await this.cloneFiles(clone);
        delete clone._id;
        try {
          const response = await this.createPoi(clone);
          if (response) {
            await this.refreshPois(this.options);
            this.createSuccess("Erfolgreich kopiert!");
            const itemToEdit = this.pois.find(
              poi => poi._id === response.data?._id
            );
            if (itemToEdit) await this.editItem(itemToEdit);
          }
        } catch (err) {
          this.createError(err);
        }
      }
    },
    // copy picture and update image-urls
    async copyPicture(picture) {
      const oldPictureId = picture.id;
      const oldPictureDatePath = getPictureUrlDatePath(picture.url);
      try {
        const newFile = await copyFileById(oldPictureId, oldPictureDatePath);
        picture.id = newFile.id;
        picture.url = newFile.url;
        let sizes = picture.imageSizes;
        if (sizes) {
          const newPictureDatePath = getPictureUrlDatePath(newFile.url);
          Object.keys(sizes).forEach(key => {
            const find = `${oldPictureDatePath ?? "/"}${oldPictureId}`;
            const replace = `${newPictureDatePath}${newFile.id}`;
            sizes[key].url = sizes[key].url.replace(find, replace);
          });
        }
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    async openCreateDialog() {
      if (this.editedItem?.categoryGroup)
        await this.$store.dispatch(
          "getCategoriesByGroup",
          this.editedItem.categoryGroup
        );

      this.typeDialog = false;
      this.dialog = true;
    },
    cancelCreateDialog() {
      this.editedItem.categoryGroup = "";
      this.typeDialog = false;
    },
    getPermissionsForRegionsByPoi(poi) {
      return this.regions
        .map(region => {
          const regionPoi = region.pois?.find(rPoi => rPoi._id === poi?._id);
          if (regionPoi)
            return `${region.title} - ${this.mapPermissions(
              regionPoi.permissions
            )}`;
          else return null;
        })
        ?.filter(item => !!item)
        ?.join("; ");
    },
    mapPermissions(permissions) {
      switch (permissions) {
        case "read":
          return "Lesen";
        case "write":
          return "Schreiben";
        case "admin":
          return "Admin";
        case "status":
          return "Statusbearbeitung";
        default:
          return "Lesen";
      }
    },
    forceUndefinedInsteadOfZeroStateValue(newValue, oldValue, property) {
      if (oldValue === newValue) {
        return;
      }
      if (oldValue === undefined && newValue === 0) {
        this.editedItem.state[property] = undefined;
      }
    }
  }
};
